var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6154 3L17.6771 11.125L19.7112 6.33667L28.6154 3Z",
    fill: "#E17726",
    stroke: "#E17726",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.38422 3L14.2251 11.2008L12.2885 6.33666L3.38422 3Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6768 21.8389L21.7664 26.3022L27.9983 28.0247L29.7835 21.9364L24.6768 21.8389Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.22772 21.9364L4.00207 28.0247L10.2232 26.3022L7.32359 21.8389L2.22772 21.9364Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88773 14.2992L8.15668 16.9209L14.3236 17.2025L14.1181 10.54L9.88773 14.2992Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.113 14.2991L17.8178 10.4641L17.6771 17.2025L23.8441 16.9208L22.113 14.2991Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2224 26.3027L13.955 24.4936L10.7418 21.9802L10.2224 26.3027Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0447 24.4936L21.7665 26.3027L21.258 21.9802L18.0447 24.4936Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7665 26.3023L18.0447 24.4932L18.3476 26.9198L18.3152 27.949L21.7665 26.3023Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2224 26.3023L13.6846 27.949L13.6629 26.9198L13.955 24.4932L10.2224 26.3023Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7494 20.3762L10.6551 19.4663L12.8406 18.4587L13.7494 20.3762Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2513 20.3762L19.1602 18.4587L21.3565 19.4663L18.2513 20.3762Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2217 26.3022L10.7627 21.8389L7.3222 21.9364L10.2217 26.3022Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2361 21.8389L21.7663 26.3022L24.6767 21.9364L21.2361 21.8389Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8441 16.9207L17.6771 17.2023L18.2505 20.3766L19.1594 18.459L21.3557 19.4665L23.8441 16.9207Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6559 19.4665L12.8414 18.459L13.7503 20.3766L14.3236 17.2023L8.15668 16.9207L10.6559 19.4665Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15668 16.9207L10.7425 21.9799L10.6559 19.4665L8.15668 16.9207Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3563 19.4665L21.2589 21.9799L23.8447 16.9207L21.3563 19.4665Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.324 17.2021L13.7505 20.3764L14.4754 24.1247L14.6377 19.1847L14.324 17.2021Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6776 17.2021L17.3746 19.1739L17.5261 24.1247L18.2509 20.3764L17.6776 17.2021Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2508 20.3763L17.5259 24.1246L18.0452 24.493L21.2586 21.9796L21.3559 19.4663L18.2508 20.3763Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6551 19.4663L10.7417 21.9796L13.955 24.493L14.4743 24.1246L13.7494 20.3763L10.6551 19.4663Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3152 27.9492L18.3476 26.92L18.0664 26.6816H13.9334L13.6629 26.92L13.6846 27.9492L10.2224 26.3025L11.4342 27.2991L13.8901 29H18.0988L20.5656 27.2991L21.7665 26.3025L18.3152 27.9492Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0445 24.4933L17.5252 24.125H14.4741L13.9549 24.4933L13.6627 26.92L13.9332 26.6816H18.0662L18.3475 26.92L18.0445 24.4933Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0803 11.6558L30 7.17083L28.6151 3L18.0447 10.8542L22.1127 14.2992L27.8577 15.9784L29.1236 14.4942L28.5719 14.0933L29.4482 13.2917L28.7774 12.7717L29.6538 12.1L29.0803 11.6558Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.17083L2.93046 11.6558L2.3354 12.1L3.22258 12.7717L2.55178 13.2917L3.42814 14.0933L2.87636 14.4942L4.14221 15.9784L9.88728 14.2992L13.9553 10.8542L3.38487 3L2 7.17083Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8587 15.978L22.1136 14.2988L23.8447 16.9205L21.2589 21.9796L24.6778 21.9363H29.7845L27.8587 15.978Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88772 14.2988L4.14273 15.978L2.22772 21.9363H7.32359L10.7424 21.9796L8.15667 16.9205L9.88772 14.2988Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6779 17.2028L18.0457 10.8544L19.7118 6.33691H12.2899L13.956 10.8544L14.3238 17.2028L14.4645 19.1961L14.4753 24.1253H17.5264L17.5372 19.1961L17.6779 17.2028Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.9cac7a339990cd1bb7301ae258ba44f3.svg";
export { ForwardRef as ReactComponent };